import React from 'react';

interface HeaderProps {
  userEmail?: string;
  onRefresh?: () => void;
  onNewRecord?: () => void;
}

export const Header: React.FC<HeaderProps> = ({ userEmail, onRefresh, onNewRecord }) => {
  const isProduction = typeof window !== 'undefined' && window.location.hostname === 'crm.madkum.pl';

  return (
    <header className="app-header">
      <div className="brand-section">
        <img src="/favicon-32x32.png" alt="MAdKuM CRM" className="brand-icon" />
        <div className="brand-title">
          <span>MAdKuM CRM</span>
          {isProduction ? (
            <span className="production-badge" data-testid="production-badge">
              PRODUCTION
            </span>
          ) : (
            <span className="staging-badge" data-testid="staging-badge">
              STAGING
            </span>
          )}
        </div>
      </div>
      <div className="header-user-info">
        {onNewRecord && (
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={onNewRecord}
            style={{ fontWeight: 600, padding: '5px 12px', backgroundColor: '#2563eb', color: '#ffffff' }}
          >
            ➕ Nowe zgłoszenie
          </button>
        )}
        {onRefresh && (
          <button
            className="btn btn-secondary btn-sm"
            onClick={onRefresh}
            title="Odśwież dane z serwera"
            style={{ color: '#f8fafc', backgroundColor: 'rgba(255,255,255,0.1)', borderColor: 'rgba(255,255,255,0.2)' }}
          >
            ↻ Odśwież
          </button>
        )}
        <span>Zalogowany: <strong className="user-email">{userEmail || 'Cloudflare Access'}</strong></span>
      </div>
    </header>
  );
};
